import defaultTransition from './transitions/default';
import infoTransition from './transitions/info';
import indexProductTransition from './transitions/index-product';

export default [defaultTransition, infoTransition, indexProductTransition];
